import type { ArbitralChatMensagemDto, InternalChatMensagem, MensagemTipo } from '../types';

const OUTBOUND_AUTORES = new Set(['SECRETARIA', 'SISTEMA']);

const tipoFromArquivo = (dto: ArbitralChatMensagemDto): MensagemTipo => {
  const mime = dto.arquivosAnexados[0]?.mimeType ?? '';
  if (mime.startsWith('image/')) return 'IMAGE';
  if (mime.startsWith('video/')) return 'VIDEO';
  return 'DOCUMENT';
};

const senderIdNuncaNull = (dto: ArbitralChatMensagemDto, outbound: boolean): string => {
  if (dto.autorUsuarioId) return dto.autorUsuarioId;
  if (outbound) return dto.autorTipo === 'SISTEMA' ? 'sistema' : 'secretaria';
  return dto.autorTipo || 'participante';
};

export const mapArbitralChatMensagem = (
  dto: ArbitralChatMensagemDto,
  conversaId: string,
  empresaId: string,
): InternalChatMensagem => {
  const outbound = OUTBOUND_AUTORES.has(dto.autorTipo);
  const tipo: MensagemTipo =
    dto.tipo === 'SISTEMA' ? 'SYSTEM' : dto.tipo === 'ARQUIVO' ? tipoFromArquivo(dto) : 'TEXT';
  const tipoSemAudio: MensagemTipo = tipo === 'AUDIO' ? 'DOCUMENT' : tipo;
  const data = dto.dataHora;
  return {
    id: dto.id,
    conversaId,
    empresaId,
    conteudo: dto.texto ?? '',
    tipo: tipoSemAudio,
    direcao: outbound ? 'OUTBOUND' : 'INBOUND',
    origem: 'CHAT_INTERNO',
    status: 'SENT',
    remetente: dto.autorNome,
    senderId: senderIdNuncaNull(dto, outbound),
    senderNome: dto.autorNome,
    dataMensagem: data,
    idMensagemInfobip: null,
    idMensagemReferenciaId: null,
    anexos: dto.arquivosAnexados.map((arquivo) => ({
      url: arquivo.url,
      filename: arquivo.nome,
      mime_type: arquivo.mimeType,
      size: arquivo.tamanhoBytes,
    })),
    metadados: { autorTipo: dto.autorTipo },
    visivelContraparte: dto.autorTipo !== 'SISTEMA',
    falhaEntrega: false,
    motivoFalha: null,
    podeRetomar: false,
    dataCriacao: data,
  };
};

export const mapArbitralChatPage = (
  page: { mensagens: ArbitralChatMensagemDto[]; total: number; page: number; limit: number },
  conversaId: string,
  empresaId: string,
): { items: InternalChatMensagem[]; nextCursor: string | null; hasMore: boolean } => {
  const hasOlder = page.page > 1;
  return {
    items: page.mensagens.map((mensagem) =>
      mapArbitralChatMensagem(mensagem, conversaId, empresaId),
    ),
    nextCursor: hasOlder ? String(page.page - 1) : null,
    hasMore: hasOlder,
  };
};
